import { Fragment, FunctionComponent } from 'react';
import { OnlyBotThree } from '@animavirtuality/onlybots-three';
import { BotMeshRenderer } from '@/components/BotMeshRenderer';
import { processAnchor } from '@/lib/anchor';
import { negative } from '@/lib/numbers';

type ThreeBotRendererProps = {
    bot: OnlyBotThree;
    useStencil?: boolean;
    zPos?: number;
};

export const ThreeBotRenderer: FunctionComponent<ThreeBotRendererProps> = ({ bot, useStencil = false, zPos }) => {
    if (!bot) {
        return null;
    }
    const anchor = processAnchor(bot.anchor);
    return (
        <group
            position={[
                negative(bot.center.x) + anchor.x / 2,
                negative(bot.center.y) + anchor.y,
                zPos || negative(bot.center.z) + anchor.z / 2,
            ]}
            castShadow
            receiveShadow
        >
            {bot.meshes.map((mesh, i) => (
                <Fragment key={i}>
                    <BotMeshRenderer mesh={mesh} useStencil={useStencil} />
                </Fragment>
            ))}
        </group>
    );
};
